import { Tag } from "~/models/list";
import { buildUrl } from "./url";

const capitalizeFirstLetter = (string: string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

const getSizeTagKey = (tag?: string) => {
  if (!tag) {
    return undefined;
  }

  const sizeMatch = tag.match(/\((micro|small|medium|large|super)\)/i);

  return sizeMatch?.[1] ?? tag;
};

export const formatSizeTag = (tag?: string) => {
  const sizeTagKey = getSizeTagKey(tag);

  if (!sizeTagKey) {
    return undefined;
  }

  const normalizedTag = sizeTagKey.toLowerCase();

  const size =
    normalizedTag.indexOf("-sized") >= 0
      ? normalizedTag
      : `${normalizedTag.replace("-size", "")}-sized`;

  return capitalizeFirstLetter(size);
};

export const formatSizeTagTooltip = (tag?: string) => {
  if (!tag) {
    return undefined;
  }

  return tag.replace(/\s*\((micro|small|medium|large|super)\)/i, "");
};

export const addBaseUrlToTags = (
  tags?: Tag[],
  baseUrl?: string,
): Tag[] | undefined => {
  if (!tags) {
    return undefined;
  }

  // no baseUrl given, just return tags as-is
  if (!baseUrl) {
    return tags;
  }

  const tagsWithBaseUrl = tags.map((tag) => {
    return {
      name: tag.name,
      url: buildUrl(baseUrl, tag.url ?? ""),
    };
  });
  return tagsWithBaseUrl;
};
